/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Website_LiveInputs */

const cs_blog_website_live = /** @type {(inputs: Blog_Website_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viditelné na webu kanceláře`)
};

const en_blog_website_live = /** @type {(inputs: Blog_Website_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live on agency website`)
};

/**
* | output |
* | --- |
* | "Live on agency website" |
*
* @param {Blog_Website_LiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_website_live = /** @type {((inputs?: Blog_Website_LiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Website_LiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_website_live(inputs)
	return cs_blog_website_live(inputs)
});